<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KQKIYT/tc-custom/9781035803538.jpg?1716639652008" alt="This image is the cover for the book Spurious Conversations with Ghosts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spurious Conversations with Ghosts
      </h1>
      <p class="bookDescription body article font2">
        <p>Ghosts A series of mild-mannered, malcontent, miscreants telling stories of mischief, malevolence, and murder. “I think that there are ghosts. I haven’t seen or heard anything. I’ve definitely felt something, but it’s not scary.” Robbie Williams “I don’t believe in ghosts.” Ryan Gosling</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Evelyne Morris
      </h2>
      
      <p class="authorDescription body article">Evelyne Morris was born in England towards the end of WW2, in 1944, but she comes from an international cultural background. Her grandparents were French/Italian and Maltese/Greek, and she was brought up in a college with foreign students from all over the world – Europe, the Far East, the Middle East, Africa and South America. She has a brother and sisters-in-law from Spain, France, and Japan, and she has daughters-in-law from Brazil and South Korea. She started writing after retirement, and this is her third novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7ee6ecc5